import { NavLink as RouterLink } from 'react-router-dom';
import { Link, SxProps } from '@mui/material';

//
//

type MenuLinkProps = {
  to: string;
  title: string;
  endIcon?: any;
  sx?: SxProps;
  target?: string;
};

export const MenuLink: React.FC<MenuLinkProps> = ({ to = '#', title, endIcon, sx, ...props }) => {
  return (
    <Link
      noWrap
      component={RouterLink}
      // to="business_customers"
      to={to}
      underline="none"
      sx={{
        typography: 'body2',
        fontWeight: 'bold',
        color: 'text.primary',
        transition: (theme) => theme.transitions.create('all'),
        '&:hover': { color: 'primary.main' },
        display: 'flex',
        alignItems: 'center',
        gap: 0.5,
        ...sx
      }}
      {...props}
    >
      {title}

      {endIcon}
    </Link>
  );
};
